import React from "react";
import {
  userData,
  messageService,
  roomData,
  logOut,
} from "./subscriberService";
import {
  timeDuration,
  activityType,
  activityType1,
  access,
  staticVar,
} from "./Constants";
import moment from "moment";
import { text } from "./TextFile";
import { isArray } from "util";
import { SVG, selectIcon } from "../components/UI/selector";
// import { ErrorUI } from '../components/UI/Modals/Modals';

const AntMediaUrl = {
  local: "wss://antmedia.tribe.fitness/WebRTCAppEE/websocket",
  develop: "wss://antmedia.tribe.fitness/WebRTCAppEE/websocket",
  staging: "wss://antmedia.tribe.fitness/staging/websocket",
  production: "wss://antmedia.tribe.fitness/prod/websocket",
};

const Urls = {
  // local: "https://local.api.tribe.fitness.ngrok.io/",
  local: "https://6764-2401-4900-1c0b-4815-4d61-b661-75cc-c81.ngrok-free.app",
  develop: "https://dev.api.tribe.fitness/",
  staging: "https://staging.api.tribe.fitness/",
  production: "https://api.tribe.fitness/",
};

const OnDemandSocket = {
  local: "https://local.api.tribe.fitness.ngrok.io?access_token=",
  // local: 'https://9940-223-239-130-112.ngrok.io?access_token=',
  develop: "https://dev.api.tribe.fitness?access_token=",
  staging: "https://staging.api.tribe.fitness?access_token=",
  production: "https://api.tribe.fitness?access_token=",
};
const stripeKey = {
  local:
    "pk_test_51JQLymGHMI8LfIVqGnFfH5EsbGKJpFVbeYwJewvQyuXcxLbSK3Pqn370NaNB0DYwebYv8hI7g6QNpHgMzMNa3v4F00FIqs52nD",
  develop:
    "pk_test_51JQLymGHMI8LfIVqGnFfH5EsbGKJpFVbeYwJewvQyuXcxLbSK3Pqn370NaNB0DYwebYv8hI7g6QNpHgMzMNa3v4F00FIqs52nD",
  staging:
    "pk_test_51JQLymGHMI8LfIVqGnFfH5EsbGKJpFVbeYwJewvQyuXcxLbSK3Pqn370NaNB0DYwebYv8hI7g6QNpHgMzMNa3v4F00FIqs52nD",
  production:
    "pk_live_51JQLymGHMI8LfIVq0IiVpHQLod04rkKrKNZTXesNW2nDOo9SY7feTuuCIZAQb1g1n8zlhNtVVj58OebD3gu92Tu100Gt9R4eNZ",
};

export const env = (status, types) => {
  // const type = "local";
  // const type = "develop";
  const type = "staging";
  // const type = "production";
  if (localStorage.getItem("local") && status === "Urls") {
    return localStorage.getItem("local") + "/";
  } else if (
    localStorage.getItem("OnDemandSocket") &&
    status === "OnDemandSocket"
  ) {
    return localStorage.getItem("OnDemandSocket") + "?access_token=";
  } else if (localStorage.getItem("AntMediaUrl") && status === "AntMediaUrl") {
    return localStorage.getItem("AntMediaUrl");
  } else {
    return eval(status)[types || type];
  }
};

// export const headerView = () => {
//     const location = useLocation();
//     return location.pathname;
// }

export const CheckValue = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "null" &&
  value !== "undefined" &&
  value !== "NaN" &&
  value !== NaN;

export const sortData = (a, b) => {
  let textA = "";
  let textB = "";
  if (typeof a === "string") {
    textA = a.toUpperCase();
  } else {
    textA = (a["name"] || a["title"] || a["label"]).toUpperCase();
  }
  if (typeof b === "string") {
    textB = b.toUpperCase();
  } else {
    textB = (b["name"] || b["title"] || b["label"]).toUpperCase();
  }
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortDataASC = (a, b) => {
  var textA = a["first_name"].toUpperCase();
  var textB = b["first_name"].toUpperCase();
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortDataDES = (a, b) => {
  var textA = a["first_name"].toUpperCase();
  var textB = b["first_name"].toUpperCase();
  return textA > textB ? -1 : textA < textB ? 1 : 0;
};
export const caloriesASC = (a, b) => {
  let textA = a["calories_burnt"] || 0;
  let textB = b["calories_burnt"] || 0;
  return textA > textB ? -1 : textA < textB ? 1 : 0;
};
export const caloriesDES = (a, b) => {
  var textA = a["calories_burnt"] || 0;
  var textB = b["calories_burnt"] || 0;
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const heartrateASC = (a, b) => {
  var textA = a["max_heart_rate_percent"] || 0;
  var textB = b["max_heart_rate_percent"] || 0;
  return textA > textB ? -1 : textA < textB ? 1 : 0;
};
export const heartrateDES = (a, b) => {
  var textA = a["max_heart_rate_percent"] || 0;
  var textB = b["max_heart_rate_percent"] || 0;
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortCategory = (a, b) => {
  var textA = a["category_position"];
  var textB = b["category_position"];
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortAnnouncement = (a, b) => {
  var textA = a["announcement_position"];
  var textB = b["announcement_position"];
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const rankIndex = (a, b) => {
  var textA = a["rank"];
  var textB = b["rank"];
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortOrder = (a, b) => {
  var textA = Number(a["exercise_order"]);
  var textB = Number(b["exercise_order"]);
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortOrder1 = (a, b) => {
  var textA = Number(a["segment_order"]);
  var textB = Number(b["segment_order"]);
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortIndex = (a, b) => {
  var textA = a["index"];
  var textB = b["index"];
  return textA < textB ? 1 : textA > textB ? -1 : 0;
};
export const sortStatus = (a, b) => {
  var textA = a["status"];
  var textB = b["status"];
  return textA < textB ? 1 : textA > textB ? -1 : 0;
};
export const participantSort = (a, b) => {
  var textA = a["video_stream"];
  var textB = b["video_stream"];
  return textA === textB ? 0 : textA ? -1 : 1;
};
export const sortDate = (a, b) => {
  var textA = +new Date(a.start_datetime);
  var textB = +new Date(b.start_datetime);
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
// export const sortData1 = (a, b) => {
//     var textA = a.label.toUpperCase();
//     var textB = b.label.toUpperCase();
//     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
// }

export const UniqueID = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

export const getvalue = (option) =>
  typeof option === "string"
    ? option
    : isArray(option)
      ? option.length
        ? getvalue(option[0])
        : ""
      : option[option.keyValue || "value"] || "";

export const getText = (id) => text[id] || "";

export const convertMinute = (minute) => {
  let minText = "Min";
  if (minute === undefined) {
    return `0 ${minText}`;
  }
  minute = Math.round(minute);
  if (minute < 60) {
    return `${minute} ${minText}${minute > 1 ? "s" : ""}`;
  } else {
    const minutes = parseInt(minute % 60, 10);
    const hour = parseInt(minute / 60, 10);
    if (minutes === 0) {
      return `${hour} Hour`;
    } else {
      return `${hour} Hour ${minutes} ${minText}${minutes > 1 ? "s" : ""}`;
    }
  }
};

export const convertMinutes = (minute, status = "second") => {
  if (minute === undefined) {
    return 0;
  }
  if (status === "second") {
    minute = Math.round(minute * 60);
  }
  return minute;
};

export const convertMinutes1 = (minute) => {
  if (minute === undefined) {
    return 0;
  }
  return Math.round(minute);
};

export const getExtension = (filename) => {
  var parts = filename.split(".");
  return parts[parts.length - 1];
};

const convertSecond = (minute) => minute * 60;
const convertMilisecond = (second) => second * 1000;
export const convertTime = (time1, type) => {
  let time = parseInt(time1, 10);
  if (type === "minute") {
    time = convertSecond(time);
    return convertMilisecond(time);
  } else if (type === "second") {
    return convertMilisecond(time);
  }
  return time;
};

export const checkLength = (data) =>
  parseInt(data, 10) < 10 ? "0" + parseInt(data, 10) : parseInt(data, 10);

export const getTime = (totalSeconds) => {
  const second = checkLength(totalSeconds % 60);
  const minute = parseInt(totalSeconds / 60, 10);
  const minutes = checkLength(parseInt(minute % 60, 10));
  const hour = checkLength(parseInt(minute / 60, 10));
  return {
    hour,
    minutes,
    totalMinute: minute,
    second,
  };
};

export const calculateTime = (second, type) => {
  const seconds = second % 60;
  const secondsP = Math.round(second);
  const secondP = pad(Math.round(seconds), 2);

  const minute = second / 60;
  const minutes = minute % 60;
  const minuteP = parseInt(minute, 10);

  const minutesP = pad(parseInt(minutes, 10), 2);

  const hour = minute / 60;
  const hourP = pad(parseInt(hour, 10), 2);

  switch (type) {
    case "h":
      return hourP;
    case "m":
      return minuteP;
    case "s":
      return secondsP;
    case "ms":
      return minuteP + ":" + secondP;
    case "hm":
      return hourP + ":" + minutesP;
    case "hms":
    default:
      return hourP + ":" + minutesP + ":" + secondP;
  }
};

const pad = (number, length) => {
  let str = "" + number;
  while (str.length < length) {
    str = "0" + str;
  }
  return str;
};

export const checkRole = (status, roles = userData.detail.roles) => {
  if (roles !== undefined) {
    if (status === "gym") {
      return roles.includes("GYM_OWNER") || roles.includes("GYM_ADMIN");
    } else if (status === "coach") {
      return roles.includes("COACH");
    } else if (status === "all") {
      return (
        roles.includes("COACH") &&
        (roles.includes("GYM_OWNER") || roles.includes("GYM_ADMIN"))
      );
    }
  }
  return false;
};

export const getActivityType = (el) => {
  const temp = activityType.filter(
    (res) => res.value === (typeof el === "string" ? el : el[0])
  );
  return temp.length ? temp[0] : [];
};

export const getActivityType1 = (el) => {
  const temp = activityType1.filter(
    (res) => res.value === (typeof el === "string" ? el : el[0])
  );
  return temp.length ? temp[0] : [];
};

export const getDuration = (el) => {
  const temp = timeDuration.filter((res) => res.value === el);
  return temp.length ? temp[0] : [];
};

// const acceptedImageTypes = 'image/heic, image/x-png, image/png, image/jpg, image/jpeg'
const acceptedImageTypesArray = staticVar.fileAccept.image
  .split(",")
  .map((item) => {
    return item.trim();
  });
export const CheckImageType = (type) => acceptedImageTypesArray.includes(type);
const acceptedCategoryImageTypesArray = staticVar.fileAccept.crop_image
  .split(",")
  .map((item) => {
    return item.trim();
  });
export const CheckCategoryImageType = (type) =>
  acceptedCategoryImageTypesArray.includes(type);

// const acceptedVideoTypes = 'video/avi,video/wmv,video/x-flv,video/3gp,video/mp4,video/mpg,video/mpeg'
// const acceptedVideoTypes = 'video/mp4'
const acceptedVideoTypesArray = staticVar.fileAccept.video
  .split(",")
  .map((item) => {
    return item.trim();
  });
export const CheckVideoType = (type) => acceptedVideoTypesArray.includes(type);

// const acceptedAudioTypes = 'audio/mp3, audio/aac, audio/flac, audio/alac, audio/wav, audio/mpeg'
const acceptedAudioTypesArray = staticVar.fileAccept.audio
  .split(",")
  .map((item) => {
    return item.trim();
  });
export const CheckAudioType = (type) => acceptedAudioTypesArray.includes(type);

export const checkTypeOfFile = (type, status) => type.startsWith(status);

export const formatBytes = (bytes, decimals = 2, condition = null) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  let dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  if (condition === null && dm !== 0 && i < 2) {
    dm = 0;
  }
  const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  if (condition != null) {
    let temp = sizes.findIndex((el) => el === condition.sizeType);
    if (temp === i) {
      if (value <= condition.size) {
        return true;
      }
      return false;
    } else if (i < temp) {
      return true;
    } else {
      return false;
    }
  }
  return value + sizes[i];
};

export const randomString = (length) => {
  var result = [];
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result.push(
      characters.charAt(Math.floor(Math.random() * charactersLength))
    );
  }
  return result.join("");
};

export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format("DD-MM-YYYY HH:MM");
  return buildDate;
};

export const checkBoxValue = (el) => {
  if (el.status === "time") {
    if (el.number === undefined || el.number === null) {
      return "0";
      // return '0 hour'
    }
    const hour = Math.round(el.number / 3600);
    return hour;
    // const number = hour <= 1 ? hour + ' hour' : hour + ' hours'
    // return number
  }
  return el.number ? Math.round(el.number) : 0;
};

export const progressEvent = (progressEvent) => {
  var percentCompleted = Math.round(
    (progressEvent.loaded * 100) / progressEvent.total
  );
  messageService.sendPercentMessage(
    percentCompleted < 100 ? percentCompleted : null
  );
};

export const setMaxDate = (startDate, max = 3) => {
  const date = new Date(startDate);
  return date.setMonth(date.getMonth() + max);
};
export const CheckWidth = (value, def = 74, clas = "") => {
  if (value !== "") {
    const div = document.createElement("div");
    div.innerText = value;
    div.className = `valueCheck ${clas}`;
    document.body.appendChild(div);
    const width1 = div.clientWidth;
    div.remove();
    return width1 + def;
  }
  return 0;
};

export const SetOption = (option) => ({
  name: option.name || undefined,
  symbol: option.symbol || undefined,
  label: option.label || option.title || undefined,
  value: getvalue(option),
  thumb: option.thumb || undefined,
  icon: option.icon || undefined,
  original: option.original || undefined,
  parent: option.parent || undefined,
  isFeature: option.isFeature || false,
  child: [],
  keyValue: "value",
});

export const GetGymId = () => {
  return userData.selectedGym.gym_id;
};

export const CheckActiveGym = (data, staticProps) => {
  let gymsArray = [];
  if (data.roles && data.roles.length) {
    if (checkRole("gym", data.roles)) {
      if (data.gymsAdded.length) {
        // gymsArray = [...data.gymsAdded];
        gymsArray = data.gymsAdded.filter((el) => el.linked_status === 1);
      }
    } else if (data.gyms.length) {
      if (staticProps.history.location.pathname.startsWith("/SignUpSteps")) {
        gymsArray = data.gyms.filter(
          (el) =>
            el.linked_status === 1 &&
            !subscriptionStatus(el.subscription_status)
        );
      } else {
        let temp = data.gyms.filter(
          (el) =>
            el.linked_status === 1 &&
            !subscriptionStatus(el.subscription_status)
        );
        let temp1 = data.gyms.filter((el) => el.linked_status === 1);
        let temp2 = data.gyms.filter(
          (el) =>
            el.linked_status === 1 && subscriptionStatus(el.subscription_status)
        );
        if (temp2.length === data.gyms.length) {
          gymsArray = [...temp1];
        } else {
          gymsArray = [...temp];
        }
      }
    }
  }
  return gymsArray;
};

export const subscriptionStatus = (status) =>
  status === "INACTIVE" || status === "NON_PAYER";

export const CheckAccess = (status) => {
  if (access[status]) {
    return access[status].value;
  }
  return true;
};

const isLetter = (str) => {
  return str.length === 1 && str.match(/[a-z]/i);
};
const isDigit = (str) => {
  return str.length === 1 && str.match(/[0-9]/i);
};

const isPassSpecial = (data) => {
  if (!data.length) {
    return false;
  } else {
    //    let letters = 0
    let numbers = 0;
    let specialChars = 0;
    for (let c of data.split("")) {
      if (isLetter(c)) {
        //    ++letters
      } else if (isDigit(c)) {
        ++numbers;
      } else {
        ++specialChars;
      }
    }
    return (
      numbers >= 2 || specialChars >= 2 || (numbers >= 1 && specialChars >= 1)
    );
  }
};

const isPassword = (data) => {
  return data.length && isPassSpecial(data);
};

export const CheckIfSpecialCharacter = (control) => {
  if (isPassword(control.value)) {
    return null;
  } else {
    return { matchingPassword: true };
  }
};

export const Logout = () => {
  roomData.sendData({});
  logOut.setLogOut(false);
  localStorage.removeItem("accessToken");
  localStorage.removeItem("formStep");
  localStorage.removeItem("gymId");
  localStorage.removeItem("setId");
  localStorage.removeItem("gymCode");
  localStorage.removeItem("approvalPending");
  staticVar.app_id = undefined;
};

export const GetOffset = (el) => {
  let x = 0;
  let y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: y, left: x };
};

export const SetInfoContainerWidth = (width) => {
  switch (true) {
    case width >= 1224 && width < 1501:
      return "calc(100% - 341px)";
    default:
      return "calc(100% - 341px)";
  }
};
export const RemoveDuplicate = (data, temp) =>
  data.filter(
    (el, index) => data.findIndex((el1) => el1[temp] === el[temp]) === index
  );

const deviceLabel = {
  audioin: "MacBook Pro Microphone (Built-in)",
  video: "FaceTime HD Camera (Built-in) (05ac:8514)",
  audioout: "MacBook Pro Speakers (Built-in)",
};
export const getDefaultAudioVideoDevice = (
  deviceList,
  deviceType = "audioout"
) => {
  if (!deviceList.length) {
    return null;
  }
  const video = deviceList.find((el) => el.label === deviceLabel[deviceType]);
  return video ? video.deviceId : deviceList[0].deviceId;
};

export const getMediaPermission = async (
  constraints,
  videoTagId,
  type = 0,
  getMedia = true
) => {
  try {
    // The MediaDevices.getUserMedia() method prompts the user for permission to use a media input
    //  which produces a MediaStream with tracks containing the requested types of media.
    await navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (mediaStream) {
        if (type) {
          var stream = document.getElementById(videoTagId);
          stream.srcObject = mediaStream;
        } else {
          const tracks = mediaStream.getVideoTracks();
          tracks.forEach(function (track) {
            track.stop();
          });
        }
      });
    return getMedia ? getMediaDevices() : { status: true };
  } catch (e) {
    console.error("getMediaPermission", e);
    return { status: false };
  }
};

export const getMediaDevices = async () => {
  try {
    const gotDevices = await navigator.mediaDevices.enumerateDevices();
    const videoInputDevices = gotDevices.filter(
      (el) => el.kind === "videoinput" && el.deviceId !== "default"
    );
    const audioInputDevices = gotDevices.filter(
      (el) => el.kind === "audioinput" && el.deviceId !== "default"
    );
    const audioOutputDevices = gotDevices.filter(
      (el) => el.kind === "audiooutput" && el.deviceId !== "default"
    );
    return {
      status: true,
      videoInputDevices,
      audioInputDevices,
      audioOutputDevices,
      gotDevices,
    };
  } catch (e) {
    return { status: false };
  }
  // Each object in the array describes one of the available media input and output devices
  //  (only device-types for which permission has been granted are "available").
  //  The order is significant - the default capture devices will be listed first.
};

export const EnableCam = async (constraints, videoTagId) => {
  await navigator.mediaDevices
    .getUserMedia(constraints)
    .then(function (mediaStream) {
      var stream = document.getElementById(videoTagId);
      mediaStream.getVideoTracks();
      stream.srcObject = mediaStream;
      stream.onloadedmetadata = async function (e) {
        await stream.play();
      };
    })
    .catch((error) => {
      //console.error("Error in EnCam", error);
      //   handleError(error);
    });
};

export const RemoveMediaInstances = (constraints, videoTagId, type) => {
  var videoElem = document.getElementById(videoTagId);
  if (!CheckValue(videoElem)) {
    return;
  }
  const stream = videoElem.srcObject;
  RemoveStream(stream);
  videoElem.srcObject = null;
  if (type) {
    setTimeout(() => {
      EnableCam(constraints, videoTagId);
    }, 500);
  }
};

export const RemoveStream = (stream) => {
  if (CheckValue(stream)) {
    const tracks = stream.getTracks();
    tracks.forEach(function (track) {
      track.stop();
    });
  }
};

export const participantStreamSort = (a, b) => {
  var textA = a["stream"];
  var textB = b["stream"];
  return textA === textB ? 0 : textA ? -1 : 1;
};
export const defaultCardValue = {
  limit: 25,
  height: 112,
  width: 220,
};
export const defaultValue = {
  limit: 12,
  height: "calc((100% - 30px) / 3)",
  width: "calc((100% - 75px) / 4)",
};

export const hangoutDefaultValue = {
  limit: 1,
  height: "calc((100% - 30px) / 3)",
  width: "calc((100% - 75px) / 5)",
};

export const setAccessControlData = (temp) => {
  Object.keys(access).forEach((el) => {
    if (CheckValue(temp[el])) {
      if (access[el].show) {
        if (el === "videoLimit") {
          let limit = Number(temp[el]);
          if (!limit > 0) {
            limit = 12;
          }
          defaultValue.limit = limit;
          access[el].value = limit.toString();
        } else {
          access[el].value = temp[el];
        }
      } else {
        delete temp[el];
      }
    }
  });
  localStorage.setItem("access", JSON.stringify(temp));
};

export const stopMediaTrack = async (constraints) => {
  try {
    // The MediaDevices.getUserMedia() method prompts the user for permission to use a media input
    //  which produces a MediaStream with tracks containing the requested types of media.
    await navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (mediaStream) {
        var tracks = mediaStream.getVideoTracks();
        tracks.forEach(function (track) {
          track.stop();
        });
      });
  } catch (e) {
    console.error(e);
  }
};
export const MediaIcon = ({ icon, clas, click }) => (
  <div className={`mediaIcon ${clas || ""}`} onClick={click}>
    <SVG className={icon} src={selectIcon(icon)} />
  </div>
);

export const capitalize = (text) => {
  return text.replace(/\b\w/g, function (m) {
    return m.toUpperCase();
  });
};

export const PromiseTimeout = (timeout) => {
  return new Promise((resolve, reject) =>
    setTimeout(() => reject("Timeout"), timeout)
  );
};

export const videoThumbnail = async (url, time) => {
  const video = document.createElement("video");
  const canvas = document.createElement("canvas");
  video.style.display = "none";
  canvas.style.display = "none";
  return await Promise.race([
    FirstFrame(video, url),
    PromiseTimeout(1000 * time),
  ])
    .then((res) => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      let imageUrl = canvas.toDataURL("image/png");
      return {
        localURL: imageUrl,
        duration: video.duration * 1000,
        file: dataURLtoFile(imageUrl, `${+new Date()}.jpg`),
      };
    })
    .catch((err) => {
      messageService.sendMessage(false);
      if (typeof err === "string") {
        if (err === "Timeout") {
          console.error(
            "Video file corrupted. Kindly try uploading a different file."
          );
        } else {
          console.error(err);
        }
      } else {
        console.error(
          "Video file corrupted. Kindly try uploading a different file."
        );
      }
      return null;
    });
};

export const audioDuration = async (url) => {
  const audio = document.createElement("audio");
  audio.style.display = "none";
  return await Promise.race([
    audioFirstFrame(audio, url),
    PromiseTimeout(1000 * 30),
  ])
    .then((res) => {
      return { duration: audio.duration * 1000 };
    })
    .catch((err) => {
      if (typeof err === "string") {
        if (err === "Timeout") {
          console.error(
            "Audio file corrupted. Kindly try uploading a different file."
          );
        } else {
          console.error(err);
        }
      } else {
        console.error(
          "Audio file corrupted. Kindly try uploading a different file."
        );
      }
      return null;
    });
};

const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

const FirstFrame = (video, url) => {
  return new Promise((resolve, reject) => {
    video.addEventListener("loadedmetadata", () => {
      // if(video.videoHeight === 0 || video.videoWidth === 0) {
      //     reject('Video file corrupted. Kindly try uploading a different file.');
      // }
      if (!CheckValue(video.duration) || video.duration < 1) {
        reject("Video file corrupted. Kindly try uploading a different file.");
      }
      video.width = video.videoWidth;
      video.height = video.videoHeight;
      video.currentTime = video.duration > 5 ? 5 : video.duration;
    });
    video.addEventListener("seeked", () => {
      if (video.videoHeight === 0 || video.videoWidth === 0) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
    video.addEventListener("onerror", (e) => reject(e));
    video.src = url;
  });
};
const audioFirstFrame = (audio, url) => {
  return new Promise((resolve, reject) => {
    audio.addEventListener("loadedmetadata", () => {
      resolve(true);
    });
    audio.addEventListener("onerror", (e) => reject(e));
    audio.src = url;
  });
};
export const addMinute = (value = 30, date = todayDate()) => {
  return date.setMinutes(date.getMinutes() + value);
};

export const todayDate = () => {
  return new Date();
};

// Check value is boolean or not
export const isBoolean = (data) => data === "true";

// Get Object value in array
export const objectFilter = (obj, predicate) =>
  Object.fromEntries(Object.entries(obj).filter(predicate));

// Check Schedule Time
export const checkTimes = (data, time) => {
  let startTime = new Date(data.start_datetime);
  startTime = startTime.setTime(startTime.getTime() - time * 60000);
  return +new Date() > startTime;
};

// Random Number
export const randomNumberInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const roundOf = (value) => {
  return parseFloat(Number(value || 0).toFixed(1));
};

export const checkNumber = (num1, num2) => {
  const new_num1 = Number(num1);
  const new_num2 = Number(num2);
  if (
    !CheckValue(new_num1) ||
    new_num1 === 0 ||
    !CheckValue(new_num2) ||
    new_num2 === 0
  ) {
    return 0;
  }
  return roundOf(num1 / num2);
};

export const setSearch = (data, history) => {
  const searchParams = new URLSearchParams(document.location.search);
  let search = [];
  let page = searchParams.get("page");
  let limit = searchParams.get("limit");
  let searchValue = searchParams.get("search");
  let status = searchParams.get("status");
  if (CheckValue(data.page)) {
    page = data.page;
  }
  if (CheckValue(data.limit)) {
    limit = data.limit;
  }
  if (CheckValue(data.status)) {
    status = data.status;
  }
  if (CheckValue(data.searchParam)) {
    searchValue = data.searchParam;
  }
  if (CheckValue(page)) {
    search.push(`page=${page}`);
  }
  if (CheckValue(limit)) {
    search.push(`limit=${limit}`);
  }
  if (CheckValue(searchValue) && searchValue !== "") {
    search.push(`search=${searchValue}`);
  }
  if (CheckValue(status) && status !== "") {
    search.push(`status=${status}`);
  }
  let newSearch = "";
  if (search.length) {
    newSearch += `?`;
    newSearch += String(search).replace(/,/g, "&");
  }

  history.replace({
    pathname: history.location.pathname,
    search: `${newSearch}`,
  });
};
